import styled from "@emotion/styled";

export const ContainerSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 99999;

  @media (min-width: 900px) {
    //background-color: lightgreen;
    left: 53%;
  }
`;
